import React from "react";
import ReactTooltip from "react-tooltip";

// Styles
import "./ActivityAction.scss";

const ActivityAction = ({
  title,
  onClick,
  hasAccess = true,
  inTrash = false,
  isFolder = false,
  isDocument = false,
  isSubFile = false,
}) => {
  const tipId = Math.floor(Math.random() * 100001).toString();
  return (
    <>
      {!hasAccess ? (
        <ReactTooltip id={tipId} place="top" effect="solid">
          Access removed
        </ReactTooltip>
      ) : inTrash ? (
        <ReactTooltip id={tipId} place="top" effect="solid">
          {isFolder ? `Folder ` : isDocument ? `Document ` : isSubFile ? `Sub-File ` : null}has been deleted
        </ReactTooltip>
      ) : null}

      <span
        className={inTrash || !hasAccess ? `activity-item-action-disabled` : `activity-item-action`}
        onClick={!inTrash && hasAccess ? onClick : null}
        data-tip
        data-for={tipId}
      >
        {title}
      </span>
    </>
  );
};

export default ActivityAction;
